"use client"

import { RequireAuth } from "@/components/require-auth"
import { DashboardLayout } from "@/components/dashboard-layout"
import { usePathname } from "@/lib/navigation"
import "@/components/admin-portal.css"

export default function AdminLayout({ children }: { children: React.ReactNode }) {
  const pathname = usePathname()
  const page = pathname.split("/")[2] || "dashboard"
  return <RequireAuth role="admin"><div className="admin-portal" data-page={page}><DashboardLayout>{children}</DashboardLayout></div></RequireAuth>
}
